import { Col, Row } from "react-bootstrap";

export default function TabSlider({
  tabs,
  currentTab,
  setCurrentTab,
  alternate,
}) {
  return (
    <Row>
      <Col xs={12}>
        <div className={`tab_slider${alternate ? "-alternate" : ""}`}>
          <div className="tabs_container">
            <ul className="tabs_inner">
              {tabs.map((tab, index) => (
                <li
                  key={index + 1}
                  onClick={() =>
                    index + 1 !== currentTab && setCurrentTab(index + 1)
                  }
                  className={`btn-outline-light fw-normal px-4 ${
                    currentTab === index + 1 && "active fw-bold"
                  }`}
                >
                  {tab.title}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Col>
    </Row>
  );
}
